module.exports = __webpack_public_path__ + "img/iconfont.bb58e7bb.svg";